module.exports = __webpack_public_path__ + "img/default-avatar.e3eb1b2c.jpg";